<template>
  <div>
    <header-applis titre="A bientôt à l’Université de Nantes"
                   sous-titre="Vous pouvez désormais engager les suites proposées et partager ces informations avec votre prochain interlocuteur à l’Université de Nantes" index-progression-courante="4"/>
    <div class="wrapper__content">
      <envoyer-recapitulatif/>
    </div>
    <footer-applis :ecran-precedent="ecranPrecedent()"></footer-applis>
  </div>
</template>

<script>
import EnvoyerRecapitulatif from '../components/EnvoyerRecapitulatif';
import HeaderApplis from '../components/HeaderApplis';
import FooterApplis from '../components/FooterApplis';

export default {
  name: 'fin',
  components: {
    FooterApplis,
    HeaderApplis,
    EnvoyerRecapitulatif
  },
  computed: {
    /**
     * Récupération des informations de parcours.
     * @returns {Object} Les informations de parcours.
     */
    informationsParcours() {
      return this.$store.getters.getInformationsParcours;
    }
  },
  methods: {
    ecranPrecedent() {
      if ('Salarié de droit privé' === this.informationsParcours.situation) {
        return 'salariedroitprivefinancement';
      } else if ('Personne en recherche d’emploi' === this.informationsParcours.situation) {
        return 'rechercheemploifinancement';
      } else if ('Dans une autre situation' === this.informationsParcours.situation) {
        return 'autresituationfinancement';
      } else {
        return 'agentpublicfinancement';
      }
    }
  }
}
</script>
